import { render, staticRenderFns } from "./UploadList.vue?vue&type=template&id=64bb9f3a&scoped=true&"
import script from "./UploadList.vue?vue&type=script&lang=js&"
export * from "./UploadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bb9f3a",
  null
  
)

export default component.exports